import { createMemo } from "solid-js"
import getTileGraphNodeLayerTerrain1Entity, { type Terrain1Entity } from "../../lib/core/entity/EntityLayerId/getTileGraphNodeLayerTerrain1Entity"
import isNotNil from "../../lib/ldsh/isNotNil"
import isIdListSame from "../signal/equals/isIdListSame"
import createSharedCachedFactory from "./createSharedCachedFactory"
import { createSharedTileGraphNodeCollectionMemo } from "./createSharedTileGraphNodeCollectionMemo"

// return all layer 1 terrain ents
export const useSharedTerrainLayer1EntsListMemo = createSharedCachedFactory((engine) => {
  const getTileGraphNodesList = createSharedTileGraphNodeCollectionMemo(engine)

  const getTerrainLayer1EntsList = createMemo<Array<Terrain1Entity>>(() => {
    const tpNodeList = getTileGraphNodesList()
    return tpNodeList.map(getTileGraphNodeLayerTerrain1Entity).filter(isNotNil)
  }, [], {
    equals: isIdListSame,
  })

  // createEffect(() => {
  //   console.log('TerrainLayer1EntsLis', getTerrainLayer1EntsList())
  // })

  return getTerrainLayer1EntsList
})